import React from 'react';
import PropTypes from 'prop-types';

import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import usStates from '../../../../../../../link-state/us-states';

const usStatesList = usStates.map(state => ({
  label: state.label,
  value: state.abbreviation,
}));

const StateField = ({
  id = 'state',
  name = 'state',
  value,
  error,
  isTouched,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  updateShipping,
  isRequired = true,
}) => (
  <LabeledSelectBox
    id={id}
    name={name}
    searchable={false}
    clearable={false}
    options={usStatesList}
    label="State *"
    onChange={event => {
      setFieldValue(name, event.target.value);
      setFieldTouched(name);

      if (updateShipping) {
        updateShipping({
          state: event.target.value,
        });
      }
    }}
    onBlur={handleBlur}
    value={value}
    autoComplete="address-level1"
    data-xc="shipping-state-field"
    errorMessage={isTouched && error ? error : null}
    required={isRequired ? '' : undefined}
    aria-required={isRequired ? '' : undefined}
    fullHeight
  />
);

StateField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
};

export default StateField;
